export function isCustomControlComplete(initializedCustomControlData: any, customControlData: any) {
    if (!customControlData) {
        return false;
    }

    for (const key of Object.keys(initializedCustomControlData)) {
        if (customControlData[key] === undefined) {
            return false;
        }
    }

    return true;
}
